import React, { Component } from 'react';
import { connect } from 'react-redux'
import {  Card,  Col, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { checkTransactionData} from './helper';
import { toast } from 'react-toastify';
import { downloadExcelFile,downloadExcelFileSuccess,downloadExcelFileFailure, meteringSystemData, meteringSystemExcelDownload, uploadMeteringSystemExcelFile, fetchMailConfig, saveMailConfig, checkAgreementStatus, notifySalesAssociate } from './action';
import moment from 'moment';
import fileSaver from 'file-saver';
import { Preloading } from '../../components/UI/Preloader/action';
import './meteringSystem.css';
import './EmailTemplateConfig/emailTemplate.css';
import TableView from '../../Analyst/Cases/Bulk-Case/TableView/index';
import TemplateModal from '../../Analyst/Cases/Bulk-Case/QuickReportBulkCase/TemplateModal';
// import Table from "../../../../components/UI/Table/Table";
import Table from "../../components/UI/Table/Table";
import { meteringSystemExcelFileDownload } from './saga';
import EmailTemplateForm from './EmailTemplateConfig/EmailTemplateForm';
import { DEFAULT_TEMPLATE_FORM } from './EmailTemplateConfig/constants';
let that;
const BULK_CASE_TABLE_COLUMN = [
    {
        Header: "Created At",
        id: "createdAt",
        accessor: d => <div>{moment(d.createdDate).format('DD-MM-YYYY')}</div>
    },
    {
        Header: "Created By",
        id: "createdBy",
        // maxWidth: 100,
        accessor: p => <div>{p.createdBy}</div>,

    },
    {
        Header: "Uploaded At",
        id: "uploadedAt",
        accessor: d => <div>{moment(d.createdDate).format('hh:mm:ss A')}</div>,
        
    },
    {
        Header: "Status",
        id: "status",
        accessor: p => <Button className={(p.status === 'PARTIAL_FAILURE' || p.status === 'FAILURE') ? 'btn btn-opacity mr-3 text-danger btn-opacity-danger download-link btn btn-link' : 'btn btn-opacity mr-3 text-success btn-opacity-success download-link btn btn-link'} onClick={() => that.downloadFailureFile(p)}>{p.status}</Button>,
        // className: 'status-column'
    },
    {
        Header: 'Action',
        id: 'action',
        accessor: p => <Button color='primary' onClick={() => that.handleOrignalFileDownload(p.fileKey)}><i className="fa fa-download"></i></Button>
    }

];

class MeteringSystemComponent extends Component {
    constructor(props) {
        super(props);  
        this.state = {
            transactionFile: null,
            uploadListData: [],
            loading: false,
            selectedCorporate: [],
            uploadError: [],
            updateFlag: false,
            caseTypeDropdownOpen: false,
            selectedCaseType: "",
            openModal : false,
            meteringSystemData : [],
            meteringSystemExcelDownload: [],
            meteriingSystemPagination:{},
            totalPages:1,
            pageSize:5,
            pageNumber:0,
            showEmailTemplateModal: false,
            emailTemplateLoading: false,
            emailTemplateStep: 0,
            emailTemplateEditMode: false,
            emailTemplateId: null,
            emailTemplateData: { ...DEFAULT_TEMPLATE_FORM },
            showAgreementStatusModal: false,
            statusCheckFile: null,
        }

        this.uploadExcel = this.uploadExcel.bind(this);
        that = this;
    }
    componentDidMount(){
        const requestData = {pageSize:this.state.pageSize,pageNumber:this.state.pageNumber};
        this.props.meteringSystemData(requestData);
    }

    componentDidUpdate(prevProps) {
        const{downloadExcelFileSuccess,downloadExcelFileFailure} =  this.props
        if (this.props.uploadFlag !== prevProps.uploadFlag) {
            if (this.props.uploadFlag) {
                this.setState({
                    formData: {},
                    transactionFile: null,
                })
            }
        }
        if (this.props.meteringSystemDataSuccess !== prevProps.meteringSystemDataSuccess) {
            this.props.preloading(false);
            this.setState({
                meteringSystemData: this.props.meteringSystemDataSuccess,
                meteriingSystemPagination:this.props.meteriingSystemPagination,
                totalPages:this.props.meteringSystemTotalPages,
            })            
        }
        if(this.props.meteringSystemDataFailure !== prevProps.meteringSystemDataFailure){
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.meteringSystemDataFailure.data}
                </div>
            );
        }
        if (this.props.meteringSystemExcelDownloadSuccess.data !== prevProps.meteringSystemExcelDownloadSuccess.data) {
            const data = this.props.meteringSystemExcelDownloadSuccess.data;
            let blob = new Blob([data], { type: "application/octet-stream" });
            fileSaver.saveAs(blob, `Metering_Master_${moment().format("DD_MMM_YYYY")}.xlsx`);
            this.props.preloading(false);
        }

        if(downloadExcelFileSuccess!==prevProps.downloadExcelFileSuccess){
            this.props.preloading(false);
            const data = this.props.downloadExcelFileSuccess.data;
            let blob = new Blob([data],  {type: "application/octet-stream"  });
            fileSaver.saveAs(blob, `Metering_Master_${moment().format("DD_MMM_YYYY")}.xlsx`);
            this.props.preloading(false);
        }
        if(downloadExcelFileFailure!==prevProps.downloadExcelFileFailure){
          this.props.preloading(false);
          <div>
          <i className="fa fa-exclamation-triangle"></i>Please Try again !!
         </div>
        }
        if(this.props.excelUploadMeteringSystemSuccess !== prevProps.excelUploadMeteringSystemSuccess){
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Metering Master Uploaded Successfully.
                </div>
            );
        }
        if(this.props.excelUploadMeteringSystemFailure !== prevProps.excelUploadMeteringSystemFailure){
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.excelUploadMeteringSystemFailure.data}
                </div>
            );
        }
        if (this.props.checkAgreementStatusSuccess !== prevProps.checkAgreementStatusSuccess
            && this.props.checkAgreementStatusSuccess
            && this.props.checkAgreementStatusSuccess.data) {
            const data = this.props.checkAgreementStatusSuccess.data;
            let blob = new Blob([data], { type: "application/octet-stream" });
            fileSaver.saveAs(blob, `Metering_Agreement_Status_${moment().format("DD_MMM_YYYY")}.xlsx`);
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Agreement status excel downloaded.
                </div>
            );
        }
        if (this.props.checkAgreementStatusFailure
            && this.props.checkAgreementStatusFailure !== prevProps.checkAgreementStatusFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.getAgreementStatusErrorMessage(this.props.checkAgreementStatusFailure)}
                </div>
            );
        }
        if (this.props.notifySalesAssociateSuccess
            && this.props.notifySalesAssociateSuccess !== prevProps.notifySalesAssociateSuccess) {
            this.props.preloading(false);
            const mailsSent = this.props.notifySalesAssociateSuccess.mailsSent || 0;
            if (mailsSent === 0) {
                toast.warn(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;No expired agreements found. No mails were sent.
                    </div>
                );
            } else {
                toast.success(
                    <div>
                        <i className="fa fa-check"></i>&nbsp;Sales associate notified. Mails sent: {mailsSent}.
                    </div>
                );
            }
        }
        if (this.props.notifySalesAssociateFailure
            && this.props.notifySalesAssociateFailure !== prevProps.notifySalesAssociateFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.getAgreementStatusErrorMessage(this.props.notifySalesAssociateFailure)}
                </div>
            );
        }
        if (this.props.mailConfig !== prevProps.mailConfig && this.props.mailConfig) {
            this.setState({
                emailTemplateEditMode: true,
                emailTemplateId: this.props.mailConfig.id,
                emailTemplateData: {
                    name: this.props.mailConfig.name || '',
                    emails: this.props.mailConfig.emails || [],
                    expiryConfig: {
                        enabled: this.props.mailConfig.expiryConfig
                            ? this.props.mailConfig.expiryConfig.enabled
                            : true,
                        mails: (this.props.mailConfig.expiryConfig
                            && this.props.mailConfig.expiryConfig.mails
                            && this.props.mailConfig.expiryConfig.mails.length > 0)
                            ? this.props.mailConfig.expiryConfig.mails
                            : DEFAULT_TEMPLATE_FORM.expiryConfig.mails
                    }
                }
            });
        }
        if (this.props.mailConfigError !== prevProps.mailConfigError && this.props.mailConfigError && !this.props.mailConfig) {
            this.setState({
                emailTemplateEditMode: false,
                emailTemplateId: null,
                emailTemplateData: { ...DEFAULT_TEMPLATE_FORM }
            });
        }
        if (this.props.saveMailConfigSuccess !== prevProps.saveMailConfigSuccess && this.props.saveMailConfigSuccess) {
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Email template config saved successfully.
                </div>
            );
            this.setState({
                showEmailTemplateModal: false,
                emailTemplateLoading: false,
                emailTemplateStep: 0
            });
        }
        if (this.props.saveMailConfigFailure !== prevProps.saveMailConfigFailure && this.props.saveMailConfigFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.saveMailConfigFailure}
                </div>
            );
            this.setState({ emailTemplateLoading: false });
        }
    }
   

    downloadFailureFile = (data) => {
        if (data.status === 'PARTIAL_FAILURE' || data.status === 'FAILURE') {
            // this.props.downloadFailedFile(data)
            console.log('dwnld failed',data)
        } else {
            // this.props.downloadOrignal(data)
            console.log('dwnld failed else blk',data)
        }
    }

    handleOrignalFileDownload = (fileKey) => {
        var requestData={fileKey:fileKey}
        // this.props.downloadOrignal(data);
        this.props.meteringSystemExcelDownload(requestData);
    }

    uploadExcel = (event) => {
        this.setState({
            transactionFile: event.target.files[0]
        },() => {
            document.getElementById('file').value = null
        })
    }
    handleUpload = () => {
        this.props.preloading(true);
        this.handleTransactioReoprtUpload({
            file: this.state.transactionFile
        })
    }

    handleTransactioReoprtUpload = (data) => {
        const validateTransactionData = checkTransactionData(data);
        console.log('validateTransactionData',validateTransactionData);
        if (validateTransactionData) {
            this.props.preloading(true);
          this.setState({
            formData: data,
             file: data.file
          })
          let transactionDataCheckRequestBody = data;
          this.props.uploadMeteringSystemExcelFile(transactionDataCheckRequestBody);
        } else {
          toast.warn(
            <div>
              <i className="fa fa-exclamation-triangle"></i>&nbsp;Required Fields are empty.
            </div>
          );
        }
      }
       checkTransactionData = (transactionData) => {
        if (transactionData.file) {
            return true
        } else {
            return false
        }
    }

    handleDownload = ()=>{
        this.props.preloading(true);
       this.props.downloadExcelFile();        
    }

    openAgreementStatusModal = () => {
        this.setState({
            showAgreementStatusModal: true,
            statusCheckFile: null
        });
    }

    closeAgreementStatusModal = () => {
        this.setState({
            showAgreementStatusModal: false,
            statusCheckFile: null
        });
    }

    uploadStatusCheckExcel = (event) => {
        this.setState({
            statusCheckFile: event.target.files[0]
        }, () => {
            document.getElementById('statusCheckFile').value = null
        })
    }

    getAgreementStatusErrorMessage = (error) => {
        if (!error) {
            return 'Failed to check agreement status.';
        }
        if (error.response && error.response.data) {
            const data = error.response.data;
            if (typeof data === 'string' && data) {
                return data;
            }
            if (data.message) {
                return data.message;
            }
        }
        return error.message || 'Failed to check agreement status.';
    }

    handleAgreementStatusCheck = () => {
        if (!this.state.statusCheckFile) {
            toast.warn(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select an excel with Corporate Id, Corporate Name and Product Name.
                </div>
            );
            return;
        }
        this.props.preloading(true);
        this.props.checkAgreementStatus({ file: this.state.statusCheckFile });
    }

    handleNotifySalesAssociate = () => {
        if (!this.state.statusCheckFile) {
            toast.warn(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select an excel with Corporate Id, Corporate Name and Product Name.
                </div>
            );
            return;
        }
        this.props.preloading(true);
        this.props.notifySalesAssociate({ file: this.state.statusCheckFile });
    }

    openEmailTemplateConfig = () => {
        this.setState({
            showEmailTemplateModal: true,
            emailTemplateStep: 0,
            emailTemplateLoading: false,
            emailTemplateEditMode: false,
            emailTemplateId: null,
            emailTemplateData: { ...DEFAULT_TEMPLATE_FORM }
        });
        this.props.fetchMailConfig();
    }

    closeEmailTemplateConfig = () => {
        this.setState({
            showEmailTemplateModal: false,
            emailTemplateStep: 0,
            emailTemplateLoading: false
        });
    }

    saveEmailTemplateConfig = (template) => {
        this.setState({ emailTemplateLoading: true });
        this.props.saveMailConfig(template, this.state.emailTemplateId);
    }

    toogleQuickReportModal = () =>{
        this.setState({ openModal : !this.state.openModal })
    }

    // uploadTemplate = (data) => {
    //     this.props.uploadManualSectionData({...data, reportRequestCaseId : this.state.quickCaseCreationRecordId, type : data.type,   corporateId : this.state.corporateId});
    //     this.props.preloading(true);
    //     this.toogleQuickReportModal();
    // }
    render() {
        return (
            <Col>
                <div>
                    <h3>Metering Master</h3>
                </div>
                <Card>
                    <Row className="excelTitle pl-2">
                        <p className="text-muted ml-1">Excel Sheet Uploader</p>
                    </Row>
                    <Row className="fileSelector pl-2 pb-4 align-items-center">
                        <div className="btn btn-primary ml-0 position-relative upload-payment-data metering-action-btn">
                            <input onChange={this.uploadExcel} type="file" accept=".xls,.xlsx" name="file" id="file" className="upload-file" title="Upload New Risk Factor" />
                            <i className="fa fa-paperclip color-888 rotate-90deg p-1" /> &nbsp;Browse File(s)
                        </div>
                        {(this.state.transactionFile) && <span className="text-muted ml-2 metering-file-name">{this.state.transactionFile.name}</span>}
                        <Button color="primary" className="ml-2 metering-action-btn" onClick={this.handleUpload}>Upload</Button>
                        <Button color="primary" className="ml-2 metering-action-btn" onClick={this.handleDownload}>Download</Button>
                        <Button color="primary" className="ml-2 metering-action-btn" onClick={this.openEmailTemplateConfig}>Email Template Config</Button>
                        <Button color="primary" className="ml-2 metering-action-btn" onClick={this.openAgreementStatusModal}>Check Agreement Status</Button>
                    </Row>

            <Table
                data={(this.state.meteringSystemData) ? this.state.meteringSystemData : []}
                columns={BULK_CASE_TABLE_COLUMN}
                defaultSorted={[
                    {
                        id: "createdAt",
                        desc: true
                    }
                ]}
                className=""
                noDataText="No Data found"
                multiSort={false}
                pages={this.state.totalPages}
                showPagination={this.state.meteriingSystemPagination.paged}
                showPaginationTop={false}
                showPaginationBottom={true}
                manual
                loading={this.props.loading}
                onPageSizeChange={(pageSize, pageIndex) => {
                        this.setState({
                            pageSize: pageSize
                        })
                        const requestData = {pageSize:pageSize,pageNumber:this.state.pageNumber};
                        this.props.meteringSystemData(requestData);
                        this.props.preloading(true);
                    }}
                    onPageChange={(pageIndex) => {
                            this.setState({
                                pageNumber: pageIndex
                            });
                            const requestData = {pageSize:this.state.pageSize,pageNumber:pageIndex};
                            this.props.meteringSystemData(requestData);
                            this.props.preloading(true);
                        }}
            />
                       <div style={{marginBottom : "1rem"}} className='download-template-text'></div>
                </Card>
                <Modal isOpen={this.state.showAgreementStatusModal} toggle={this.closeAgreementStatusModal}>
                    <ModalHeader toggle={this.closeAgreementStatusModal}>Check Agreement Status</ModalHeader>
                    <ModalBody>
                        <p className="text-muted">Upload excel with Corporate Id, Corporate Name and Product Name.</p>
                        <div className="btn btn-primary position-relative upload-payment-data metering-action-btn">
                            <input onChange={this.uploadStatusCheckExcel} type="file" accept=".xls,.xlsx" name="statusCheckFile" id="statusCheckFile" className="upload-file" title="Upload agreement status excel" />
                            <i className="fa fa-paperclip color-888 rotate-90deg p-1" /> &nbsp;Browse File
                        </div>
                        {(this.state.statusCheckFile) && <div className="text-muted mt-2">{this.state.statusCheckFile.name}</div>}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeAgreementStatusModal}>Cancel</Button>
                        <Button color="primary" onClick={this.handleAgreementStatusCheck}>Upload</Button>
                        <Button color="primary" onClick={this.handleNotifySalesAssociate}>Notify Sales Associate</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showEmailTemplateModal} size="lg" className="template-modal">
                    <ModalHeader toggle={this.closeEmailTemplateConfig}>
                        {this.state.emailTemplateEditMode ? 'Edit Email Template Config' : 'Email Template Config'}
                    </ModalHeader>
                    <ModalBody>
                        <EmailTemplateForm
                            initialData={this.state.emailTemplateData}
                            onSave={this.saveEmailTemplateConfig}
                            onCancel={this.closeEmailTemplateConfig}
                            isEditMode={this.state.emailTemplateEditMode}
                            loading={this.state.emailTemplateLoading}
                            currentStep={this.state.emailTemplateStep}
                            onNextStep={() => this.setState({ emailTemplateStep: 1 })}
                            onPrevStep={() => this.setState({ emailTemplateStep: 0 })}
                        />
                    </ModalBody>
                </Modal>
            </Col>
        )};

}
const mapStateToProps = (state, ownProps) => ({
    excelUploadMeteringSystemSuccess: state.corporateListData.excelUploadMeteringSystemSuccess,
    excelUploadMeteringSystemFailure: state.corporateListData.excelUploadMeteringSystemFailure,
    downloadExcelFile : state.MeteringSystemReducer.meterdownloadExcelFile,
    downloadExcelFileSuccess : state.MeteringSystemReducer.downloadExcelFileSuccess, 
    downloadExcelFileFailure : state.MeteringSystemReducer.downloadExcelFileFailure,
    meteringSystemDataSuccess : state.MeteringSystemReducer.meteringSystem,
    meteriingSystemPagination: state.MeteringSystemReducer.meteringSystemPagination,
    meteringSystemTotalPages: state.MeteringSystemReducer.meteringSystemTotalPages,
    meteringSystemDataFailure : state.MeteringSystemReducer.meteringSystemError,
    meteringSystemExcelDownloadSuccess : state.MeteringSystemReducer.meteringSystemExcelDownload,
    meteringSystemExcelDownloadFailure : state.MeteringSystemReducer.meteringSystemExcelDownloadError,
    mailConfig: state.MeteringSystemReducer.mailConfig,
    mailConfigError: state.MeteringSystemReducer.mailConfigError,
    saveMailConfigSuccess: state.MeteringSystemReducer.saveMailConfigSuccess,
    saveMailConfigFailure: state.MeteringSystemReducer.saveMailConfigFailure,
    checkAgreementStatusSuccess: state.MeteringSystemReducer.checkAgreementStatusSuccess,
    checkAgreementStatusFailure: state.MeteringSystemReducer.checkAgreementStatusFailure,
    notifySalesAssociateSuccess: state.MeteringSystemReducer.notifySalesAssociateSuccess,
    notifySalesAssociateFailure: state.MeteringSystemReducer.notifySalesAssociateFailure
  })
  

const mapDispatchToProps = (dispatch) => ({
    uploadMeteringSystemExcelFile: (data) => { dispatch(uploadMeteringSystemExcelFile(data)) },
    downloadExcelFile:(data)=>{dispatch(downloadExcelFile(data))},
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    meteringSystemData: (data) => {dispatch(meteringSystemData(data))},
    meteringSystemExcelDownload: (data) => {dispatch(meteringSystemExcelDownload(data))},
    fetchMailConfig: () => { dispatch(fetchMailConfig()) },
    saveMailConfig: (data, id) => { dispatch(saveMailConfig(data, id)) },
    checkAgreementStatus: (data) => { dispatch(checkAgreementStatus(data)) },
    notifySalesAssociate: (data) => { dispatch(notifySalesAssociate(data)) }
});
  
export default connect(mapStateToProps, mapDispatchToProps)(MeteringSystemComponent);